<template>
  <div>
    <div class="add-new">
      <v-btn
        small
        class="btn-primary btn-add"
        :class="!isShowList ? 'add-show' : 'add-hide'"
        @click="toggleShowComponent()"
      >
        Component
        <v-icon right dark>
          fa-caret-down
        </v-icon>
      </v-btn>
    </div>

    <div
      class="component-list"
      :class="isShowList ? 'component-show' : 'component-hide'"
    >
      <div class="component-item">
        <div class="component-item-title">
          <div>Component</div>
          <div>
            <v-icon @click="toggleShowComponent()">fa-caret-up</v-icon>
          </div>
        </div>
        <div class="component-item-container">
          <v-row class="m-r-0 m-l-0">
            <v-col
              cols="6"
              v-for="(item, index) in componentItems"
              :key="index"
              class="text-center"
            >
              <div
                class="drag-drawflow"
                draggable="true"
                :data-node="JSON.stringify(item)"
                @dragstart="dragstart"
              >
                <div>
                  <v-icon>{{ item.icon }}</v-icon>
                </div>
                <div>{{ paletteTitle(item.title) }}</div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    componentItems: Array
  },
  data() {
    return {
      isShowList: true
    }
  },
  methods: {
    async toggleShowComponent() {
      if (!this.isShowList) {
        const id = document.getElementsByClassName(
          'component-item-container'
        )[0]
        if (id) {
          id.style.visibility = 'hidden'

          setTimeout(() => {
            id.style.visibility = 'visible'
          }, 150)
        }
      }
      this.isShowList = !this.isShowList
    },
    paletteTitle(title) {
      if (title === 'Intent mapping') return 'Intent map'
      else if (title === 'Stamp service') return 'Stamp'
      return title
    },
    dragstart(ev) {
      this.$emit('dragstart', ev)
    }
  }
}
</script>
